import { isNull } from 'lodash';
import { useTranslation } from 'react-i18next';
import useEnv from '@shared/useEnv';
import EmbeddedMap from '@components/shared/EmbeddedMap';
import Header from '@components/shared/Header';

type Props = {
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  hideLocation?: boolean;
};

const Location = ({
  address = null,
  hideLocation = false,
  latitude = null,
  longitude = null,
}: Props) => {
  const { googleMapsKey: key } = useEnv();
  const { t } = useTranslation('building');

  if (isNull(key) || isNull(address)) return null;

  return (
    <div>
      <Header>{t('location')}</Header>
      <EmbeddedMap
        address={address}
        hideLocation={hideLocation}
        latitude={latitude}
        longitude={longitude}
      />
    </div>
  );
};

export default Location;
